import ERRORS from './error'
export const LOGIC_HELPER = {
  var: {
    title: '定义',
    usage: 'var 包装价 = 1 * 1',
    desc: '定义一个变量, 这个变量可以是其他公式计算的结果',
    example: 'var 包装价 = 1 * 1',
    type: 'variable'
  },
  IF: {
    title: '条件语句',
    usage: 'IF(表达式,成立时输出,不成立时输出)',
    desc: '设置判断条件,然后根据判断结果TRUE或FALSE来返回不同的文本',
    example: 'IF(分数>60,"及格","不及格") => 如果分数大于60分,则记为及格,否则记为不及格'
  },

  OR: {
    title: '求或',
    usage: 'OR(表达式1,表达式2,表达式3,...)',
    desc: '判断多个条件中是否有任意一个条件成立,只要有一个参数为逻辑值TRUE,OR函数就返回TRUE。如果所有参数都为逻辑值FALSE,OR函数才返回FALSE',
    example: 'OR(数学分数 >= 60,语文分数 >= 60,英语分数 >= 60) => 只要有一个条件成立,结果即为TRUE,否则为FALSE'
  },

  AND: {
    title: '求同',
    usage: 'AND(表达式1,表达式2,表达式3,...)',
    desc: '判断多个条件是否同时成立,如果所有参数都为逻辑值TRUE,AND函数将返回TRUE,只要其中一个参数为逻辑值FALSE,AND函数就返回FALSE',
    example: 'AND(数学分数 >= 60,语文分数 >= 60,英语分数 >= 60) => 只有所有条件成立结果才为TRUE,否则为FALSE'
  },

  NOT: {
    title: '求反',
    usage: 'NOT(表达式)',
    desc: '对逻辑值求反。如果逻辑值为FALSE,NOT函数将返回TRUE;如果逻辑值为TRUE,NOT函数将返回FALSE',
    example: 'NOT(数学分数 >= 60) => 如果分数大于等于60返回FALSE,否则返回TRUE'
  },

  ISEMPTY: {
    title: '判断为空',
    usage: 'ISEMPTY(字段)',
    desc: '判断单元格是否为空,如果为空,返回TRUE,否则返回FALSE',
    example: 'ISEMPTY(客户手机号) => 有手机号返回FALSE,否则返回TRUE'
  },

  INCLUDE: {
    title: '判断包含',
    usage: 'INCLUDE(原文本,检索的字符)',
    desc: '判断一个文本中是否包含指定的字符内容',
    example: 'INCLUDE("中犇科技是最值得客户信赖的互联网解决方案提供商", "中犇科技") => 结果为TRUE'
  },

  FALSE: {
    title: '返回false',
    usage: 'FALSE()',
    desc: '直接返回逻辑值FALSE',
    example: 'FALSE() => 结果为FALSE'
  },

  TRUE: {
    title: '返回true',
    usage: 'TRUE()',
    desc: '直接返回逻辑值TRUE',
    example: 'TRUE() => 结果为TRUE'
  }
}

export const IF = (...args) => {
  if (args.length < 3) ERRORS.ARG_LENGTH_ERROR('IF', 3, args.length)
  return args[0] ? args[1] : args[2]
}

export const OR = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('OR', 1, args.length, false)
  return args.some(item => !!item)
}

export const AND = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('AND', 1, args.length, false)
  return args.every(item => !!item)
}

export const NOT = (...args) => {
  if (!args.length) ERRORS.ARG_LENGTH_ERROR('NOT', 1, args.length)
  return !args[0]
}

export const ISEMPTY = (...args) => {
  // if (!args.length) ERRORS.ARG_LENGTH_ERROR('ISEMPTY', 1, args.length)
  let value = args[0]
  return typeof value === 'string' ? value.trim() === '' : Array.isArray(value) ? value.length === 0 : value === null || value === undefined
}

export const INCLUDE = (...args) => {
  if (args.length < 2) ERRORS.ARG_LENGTH_ERROR('INCLUDE', 2, args.length)
  return `${args[0]}`.indexOf(args[1]) != -1
}

export const FALSE = () => false
export const TRUE = () => true
